module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', [_c('b-input', {
    attrs: {
      "type": "password",
      "placeholder": "Regular password input"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "type": "password",
      "placeholder": "Password reveal input",
      "password-reveal": ""
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-681e00ed"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/input/examples/ExPassword.vue
// module id = 1102
// module chunks = 13 217